import { useEffect, useState } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Datepicker, HookFormResolver } from '@dec/shared';
import { type HookFormMethods } from '@dec/shared';
import { Col, Row } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import ChartStackedBar from 'app/components/chart/stacked-bar';
import { type StackedBarDataSet } from 'app/components/chart/types';
import { factoryYup } from 'app/core/factory-yup';
import { getPaymentByTaxReport } from 'app/modules/ManagementReport/hooks';
import i18next from 'i18next';
import moment from 'moment';

import { label } from '../translation';
const yup = factoryYup();

const validations = yup.object().shape({
  dateFrom: yup.date().required(),
  dateTo: yup.date().when('dateFrom', {
    is: (dateFrom: Date) => !!dateFrom,
    then: (schema) =>
      schema
        .required()
        .min(yup.ref('dateFrom'), () =>
          i18next.t('management-report.validations.dateToGreaterThan')
        )
        .test(
          'max-twelve-months',
          i18next.t('management-report.validations.dateLessThreeMonths'),
          function (value) {
            const { dateFrom } = this.parent;
            if (!dateFrom || !value) return true;
            const limit = moment(dateFrom).add(12, 'month').toDate();
            return moment(value).isSameOrBefore(limit);
          }
        ),
    otherwise: (schema) => schema.required()
  })
});
const dateTo = moment().toDate();
const dateFrom = moment(dateTo).subtract(12, 'month').toDate();

export const PaymentByTax = () => {
  const [data, setData] = useState<StackedBarDataSet>();
  const [initialValues, setInitialValues] = useState<any>({ dateTo, dateFrom });
  const consultar = async (values: any) => {
    const data = await getPaymentByTaxReport(values, true);
    setInitialValues(values);
    setData(undefined);
    setData(data);
  };
  useEffect(() => {
    consultar(initialValues);
  }, []);

  const onSearch = async (values: any) => {
    await consultar(values);
  };

  if (data === undefined) {
    return <></>;
  }
  return (
    <>
      <div className="pb-2 pt-2" />

      <HookFormResolver validations={validations} onSubmit={onSearch} initialValues={initialValues}>
        {({ formState: { errors }, reset, setValue, control }: HookFormMethods) => {
          return (
            <>
              <Row>
                <Col>
                  <Datepicker label={label('dateFrom')} name={'dateFrom'} />
                </Col>
                <Col>
                  <Datepicker label={label('dateTo')} name={'dateTo'} />
                </Col>
              </Row>

              <BtnToolbar>
                <BtnGroup>
                  <Button
                    action={ButtonAction.clean}
                    onClick={() => {
                      reset({ dateTo, dateFrom });
                      consultar({ dateTo, dateFrom });
                    }}
                  />
                </BtnGroup>
                <BtnGroup>
                  <Button action={ButtonAction.find} variant="primary" type={'submit'} />
                </BtnGroup>
              </BtnToolbar>
            </>
          );
        }}
      </HookFormResolver>
      <ChartStackedBar data={data} />
    </>
  );
};
